import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setContext } from '@/lib/sentry';
import { useAuth } from './useAuth';
import { useSubscriptionSafe } from '@/contexts/SubscriptionContext';

/**
 * Hook qui enrichit automatiquement Sentry avec le contexte métier
 * - Informations entreprise (plan, statut)
 * - Page courante (path, search params)
 *
 * À appeler dans App.tsx pour activer l'enrichissement global
 * Utilise useSubscriptionSafe pour éviter de crasher si le context n'est pas prêt
 */
export function useSentryContext() {
  const { user } = useAuth();
  const subscriptionContext = useSubscriptionSafe();
  const location = useLocation();

  useEffect(() => {
    // Ne pas enrichir si l'utilisateur n'est pas connecté
    if (!user) {
      return;
    }

    // Si le context subscription n'est pas disponible, utiliser des valeurs par défaut
    const plan = subscriptionContext?.plan || 'free';
    const status = subscriptionContext?.status || 'unknown';
    const subscribed = subscriptionContext?.subscribed || false;

    // Contexte entreprise et abonnement
    setContext('subscription', {
      plan,
      status,
      subscribed
    });

    // Contexte page courante
    setContext('page', {
      path: location.pathname,
      search: location.search,
      fullUrl: `${location.pathname}${location.search}`
    });
  }, [user, subscriptionContext, location.pathname, location.search]);
}
